/**
 * Registers the Pendo page-hit destination.
 *
 * Kept out of the client plugin so the composition root stays wiring only, matching
 * `register-google-analytics-provider.utils.ts`. Owning the enabled check here means the caller
 * needs no branch of its own.
 */

import { analyticsService } from '../services/analytics.service'
import { PendoAnalyticsProvider } from '../providers/pendo-analytics.provider'
import { resolveAppFlavor } from './page-hit'

export interface PendoAnalyticsRegistrationConfig {
  enabled: boolean
  /** App name used to resolve the page-hit flavor. */
  appName: unknown
}

export function registerPendoAnalyticsProvider({ enabled, appName }: PendoAnalyticsRegistrationConfig): void {
  if (!enabled) return

  analyticsService.registerProvider('pendoAnalytics', new PendoAnalyticsProvider(resolveAppFlavor(appName)))
}
